import { render } from "./ShiftTasksAndParamsBlock.vue?vue&type=template&id=96106574&scoped=true"
import script from "./ShiftTasksAndParamsBlock.vue?vue&type=script&lang=js"
export * from "./ShiftTasksAndParamsBlock.vue?vue&type=script&lang=js"

import "./ShiftTasksAndParamsBlock.vue?vue&type=style&index=0&id=96106574&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96106574"]])

export default __exports__